<template>
  <e-charts
    ref="line"
    autoresize
    :option="option"
    theme="theme-color"
    auto-resize
    :update-options="{notMerge:true}"
  />
</template>

<script>
import ECharts from 'vue-echarts'
import { ref, toRef, watch } from '@vue/composition-api'
import { formatCurrency } from '@core/utils/utils'
import { registerTheme, use } from 'echarts/core'
import {
  BarChart, LineChart, LinesChart, PieChart,
} from 'echarts/charts'
import {
  DatasetComponent,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  LegendScrollComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components'
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers'
import theme from '../theme.json'

use([
  BarChart,
  LineChart,
  PieChart,
  LinesChart,
  LegendScrollComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  CanvasRenderer,
  SVGRenderer,
  ToolboxComponent,
  DataZoomComponent,
])
registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    mobile: {
      type: Object,
      default: () => ({ mobile: false }),
    },
    chartData: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const chartData = toRef(props, 'chartData')
    const dataset = {
      dimensions: ['name', 'total_advanced'],
      source: [],
    }
    const option = ref({
      grid: {
        left: 170,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: ([data]) => `<strong>${data.data[0]}</strong><br/>${formatCurrency(data.data[1])}`,
      },
      dataset: [dataset],
      yAxis: {
        inverse: true,
        type: 'category',
        axisLabel: {
          interval: 0,
          rotate: 30,
        },
      },
      xAxis: {
        axisLabel: {
          formatter: formatCurrency,
          rotate: 30,
        },
      },
      series: [
        {
          type: 'bar',
          colorBy: 'data',
          encode: { y: 'short', x: 'total_advanced' },
        },
      ],
    })

    const getName = (i, ranges, range) => {
      if (i === ranges.length - 1) { return `${range.min}-Acima` }
      return (range.min === 0 ? 'Não informado' : `${range.min}-${range.max}`)
    }

    watch(chartData, data => {
      if (!data || Object.keys(data).length === 0) return

      const years = Object.keys(data)
      const ranges = years.length > 0 ? data[years[0]].range_age : []

      dataset.source.splice(0, dataset.source.length)
      const labels = ranges.map((range, i) => getName(i, ranges, range))
      ranges.forEach((range, index) => {
        const label = labels[index]
        const value = range.value / 100
        dataset.source.push([label, value])
      })
    })

    return {
      option,
    }
  },
}
</script>
